module.exports = __webpack_public_path__ + "img/fwx8.102724b8.png";